import "./Faq.scss";

export const Faq = () => (
  <svg id="uuid-5ed5d6d2-50cb-45f0-a840-d60ef8fdc534_faq" viewBox="0 0 51.28 38.87" className="faqIcon">
    <defs>
      <linearGradient id="uuid-508fab0e-a2c8-4b1c-ac19-4c84b8079229_faq" x1="13.79" y1="14.33" x2="51.28" y2="14.33" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#95d0e5" />
        <stop offset="1" stopColor="#009ee3" />
      </linearGradient>
      <linearGradient id="uuid-20baeb00-d428-4b67-827e-2f5e1366bbc0_faq" x1="0" y1="24.55" x2="37.49" y2="24.55" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#4b78c6" />
        <stop offset="1" stopColor="#2b4281" />
      </linearGradient>
    </defs>
    <g id="uuid-a72da9ff-3f2a-4a53-9e03-e6db8678a7a0_faq">
      <path
        className="uuid-cdb46008-dc09-4438-af1e-c07d21467bd3"
        d="m51.28,18.24V4.97c0-2.75-2.23-4.97-4.97-4.97h-27.54c-2.75,0-4.97,2.23-4.97,4.97v13.27c0,2.75,2.23,4.97,4.97,4.97h27.54l4.86,5.44s.15-11.06.11-10.41Z"
      />
      <path
        className="uuid-13ccaeea-03e6-4cb3-ad6b-aea79d564577"
        d="m32.62,15.17c-.27,0-.5-.21-.52-.48v-.14c-.15-1.3.28-2.71,1.48-4.15,1.08-1.27,1.68-2.21,1.68-3.29,0-1.22-.77-2.04-2.28-2.06-.65,0-1.36.17-1.93.44-.28.14-.61,0-.72-.28l-.2-.53c-.09-.24,0-.52.23-.64.81-.44,1.96-.72,3.04-.72,2.76,0,4.01,1.7,4.01,3.53,0,1.63-.91,2.81-2.06,4.17-1.06,1.25-1.44,2.3-1.37,3.53v.08c.01.3-.22.54-.52.54h-.84Zm-.99,3.08c.11-.74.67-1.24,1.42-1.24.84,0,1.42.62,1.42,1.51,0,.69-.38,1.26-1.01,1.43-1.03.29-1.99-.65-1.83-1.71Z"
      />
      <path
        className="uuid-4b88508d-7c65-4494-9b02-abc52aaa5064"
        d="m18.76,23.22c-2.75,0-4.97-2.23-4.97-4.97v-8.03H4.98C2.23,10.22,0,12.44,0,15.19v13.27c-.04-.65.11,10.41.11,10.41l4.86-5.44h27.54c2.75,0,4.97-2.23,4.97-4.97v-5.25h-18.73Z"
      />
    </g>
  </svg>
);
